import { Service } from "../../../../feature-app-core/src/services";

const url = {
  DECLINE_MANUAL_QUOTE: '/api/v1/loan/declineManualQuoteLoan',
};

export class ManualQuoteService extends Service {

  declineManualQuote(loanChangeRequest: any) {
    return this.post(url.DECLINE_MANUAL_QUOTE, loanChangeRequest);
  }

}
